/**
 * Avisos de uma linha do card "Convênios a conferir", em dois níveis: o que falta
 * resolver (texto em âmbar, com a ação ao lado) e, abaixo, os vencimentos próximos
 * como legenda discreta. O painel e o "Resolver" seguem com a lista completa
 * (InsuranceAlertList), aqui a linha precisa ser lida de relance.
 */
import React from 'react';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { ALERT_CRITICAL, sortAlerts } from '../../../appointments/v2/utils/insuranceAlerts';
import styles from './InsurancePending.module.css';

function PendingRowAlerts({ alerts, alertAction }) {
  const sorted = sortAlerts(alerts);
  const critical = sorted.filter((alert) => alert.level === ALERT_CRITICAL);
  const info = sorted.filter((alert) => alert.level !== ALERT_CRITICAL);

  return (
    <div className={styles.rowAlerts}>
      {critical.map((alert) => {
        const action = alertAction ? alertAction(alert) : null;
        return (
          <p key={alert.code} className={styles.rowProblem}>
            <ReportProblemOutlinedIcon className={styles.rowProblemIcon} />
            <span>{alert.message}</span>
            {action && (
              <button type="button" className={styles.rowProblemAction} onClick={action.onClick}>
                {action.label}
              </button>
            )}
          </p>
        );
      })}
      {info.map((alert) => (
        <p key={alert.code} className={styles.rowNote}>{alert.message}</p>
      ))}
    </div>
  );
}

export default PendingRowAlerts;
